<template>
    <div>
        <mainindex>
            <!--<div class="log" v-if="islogmode && gen._UID">-->
            <div v-if="islogmode" class="log">
                <d-close @close="islogmode = !islogmode" />
                <mainlog></mainlog>
            </div>
            <div v-if="!islogmode" class="content">
                <!--<div class="content" v-if="gen._UID && !islogmode">-->
                <!--HEADER-->
                <page-header v-if="mode !== 'home'" :cur-page="mode" :menu-tree="menu" @nav="go($event)" @openlogspanel="toggleLogsPanel" @save-prj="savePrj()" @new-prj="newPrj"></page-header>
                <!--HEADER-->

                <!--BODY-->
                <div :class="[paddingClass]" class="body">
                    <router-view v-if="$route.name !== null"></router-view>
                    <div v-else>
                        <template v-if="mode === 'home'">
                            <home @nav="go($event)" @new-prj="newPrj" @load-prj="go('projects.my')"></home>
                        </template>
                        <template v-else-if="mode === 'startprj'">
                            <start-prj @nav="go($event)"></start-prj>
                        </template>
                        <template v-else-if="mode === 'projects.my'">
                            <prj-finder
                                :cols="[
                                    { id: 'id', title: 'id', order: 0 },
                                    { id: 'des', title: _trans('reference'), order: 6 },
                                    { id: 'status', title: _trans('Status'), order: 4 },
                                    { id: 'lastedit', title: _trans('Last Edit'), order: 11 },
                                    { id: 'shop', title: _trans('Shop'), order: 8 },
                                    { id: 'owner', title: _trans('User') },
                                    { id: 'open', title: null },
                                    { id: 'delete', title: null }
                                ]"
                                :rows-number="10"
                                filter="MY"
                                order-by="11D"
                                title="My Projects"
                                @open="openPrj($event)"
                            ></prj-finder>
                            <!-- <prj-finder filter="AWAITING" key="AWAITING" title="Projects Awaiting Approval" :rows-number="5" order-by="11D"></prj-finder> -->
                        </template>
                        <!-- <template v-else-if="mode==='projects.ext'">
                          <prj-finder filter="UNASSIGNED" key="UNASSIGNED" title="Unassigned Projects" :rows-number="5" order-by="11D"></prj-finder>
                          <prj-finder filter="OTHERPRJ" key="OTHERPRJ" title="Other Projects In My Store" :rows-number="5" order-by="11D"></prj-finder>
                        </template>
                        <template v-else-if="mode==='projects.clinv'">
                          <prj-finder filter="CLOSED" key="CLOSED" title="Closed Projects" :rows-number="5" order-by="11D"></prj-finder>
                          <prj-finder filter="INACTIVE" key="INACTIVE" title="Inactive Projects" :rows-number="5" order-by="11D"></prj-finder>
                        </template>
                        <template v-else-if="mode==='notifications'">
                          <notifications></notifications>
                        </template> -->
                        <template v-else-if="mode === 'itemsearch'">
                            <article-search @nav="go($event)"></article-search>
                        </template>
                        <template v-else-if="mode === 'configurator'">
                            <configure :lockvisual="lockvisualCustomized" @nav="go($event)"></configure>
                        </template>
                        <template v-else-if="mode === '3dview'">
                            <view3d :lockvisual="lockvisualCustomized" :load-header-on-start="true" @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === '2dview'">
                            <view2d @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === 'offerview'">
                            <offer @nav="go($event)" @save-prj="savePrj()"></offer>
                        </template>
                        <template v-else-if="mode === 'summary'">
                            <prj-summary />
                        </template>
                        <template v-else-if="mode === 'customerinfo'">
                            <customer-info />
                        </template>
                        <template v-else-if="mode === 'prjlog'">
                            <prj-log />
                        </template>
                        <template v-else-if="mode === 'delivery'">
                            <delivery />
                        </template>
                        <template v-else-if="mode === 'promotions'">
                            <promotions />
                        </template>
                        <template v-else-if="mode === 'json'">
                            <d-json :value="prj" />
                        </template>
                        <template v-else-if="mode === 'myprofile'">
                            <my-profile />
                        </template>
                        <template v-else>
                            <h1>::::{{ mode }}::::</h1>
                        </template>
                    </div>
                </div>
                <!--BODY-->
            </div>
            <home v-else @nav="go($event)" @new-prj="newPrj" @load-prj="go('projects.my')"></home>
        </mainindex>
        <d-msg v-if="askend" sizex="3fr" text="close current session" title="CloseSession" yesno @close="disconnect($event)" />
        <!--<div class="nav fixed-bottom border">
          <button @click="islogmode = !islogmode" v-html="_trans('LOGS')"></button>
        </div>-->
        <app-settings v-if="showSettings" @close="showSettings = false"></app-settings>
    </div>
</template>

<script>
    import "../../../scss/cattelan.scss";
    import index from "@configurator/index";

    export default {
        mixins: [index],
        computed: {
            config() {
                return this.$store.getters["getConfig"];
            },
            lockvisualCustomized() {
                if (this.config && this.config.customization && this.config.customization.lockvisual) return this.config.customization.lockvisual;
                else return "60;45;45;false;0;360;0;90;1000;5000;false";
            }
        },
        methods: {
            resetCustomerParams() {
                let currencyCod = this.preferences.config.currency || "EUR";
                this.$set(this.prj, "currency", currencyCod);
                this.$set(this.prj, "currencyJSON", this.currencies[currencyCod]);
                this.$set(this.prj, "currencyIncrease", 0.1);
            },
            onNewProject() {
                this.go("startprj");
            }
        }
    };
</script>

<style lang="scss" scoped>
    .no-menu {
        height: 100vh;
        padding-top: 0;
    }

    .mid-menu {
        height: 100vh;
        padding-top: 70px;
        //padding-top: 2.512rem;
        @include media-breakpoint-down(md) {
        }
    }

    .full-menu {
        padding-top: 70px;
        @include media-breakpoint-down(md) {
            //padding-top: 5.15rem;
        }
    }

    .username {
        position: absolute;
        right: 20px;
        bottom: 5px;
    }

    .catalog {
        position: absolute;
        right: 200px;
        width: 120px;
        height: 38px;
        color: $white;
        border: 0;
        background-color: $color;
    }

    .catalogoption {
        font-size: 0.8em;
        font-weight: normal;
    }

    .body {
        overflow: auto;
        height: 100vh !important;
        background: $appBackground !important;
    }

    .close {
        z-index: 10;
        padding-top: 60px;
    }
</style>



// WEBPACK FOOTER //
// src/custom/cattelan/start.vue